import { urlAutenticacionOkta, urlAuthSSOLogin } from 'constants/urls';

export const isLoginOld = window.location.pathname === '/login-old';

function isSiteOnline(url, callback) {
  var img = document.createElement('img');
  img.onload = function () {
    callback(true);
  };
  img.onerror = function () {
    callback(false);
  };
  img.src = url;
}

export const verificarIsOktaOrSso = () => {
  var imgUrl = 'https://awawwscm1404002.r1-core.r1.aig.net/AIG_logo.jpg';
  isSiteOnline(imgUrl, function (found) {
    if (found) {
      window.location.href = urlAutenticacionOkta;
    } else {
      window.location.href = urlAuthSSOLogin;
    }
  });
};
